<template lang="pug">
  .request-builder-filter(ref='newFilter')
    .filters
      vue-good-table(
        :columns='columns',
        :rows='filters',
        @on-row-click='onRowClick',
        styleClass="vgt-table-fp",
        :resizeableColumns="true"
      )
        .empty-filter(slot="emptystate") {{'editor.filter.placeholder'|translate}}
        template(slot='table-row', slot-scope='props')
          span.display-actions(v-if="props.column.field === 'options'")
            fpui-button(color="blue",unbordered,reverse,icon="fpui fpui-pencil",@click="edit(props.row,$event)")
            fpui-button(color="red",unbordered,reverse,icon="fpui fpui-trash",@click="remove(props.row,$event)")
          span(v-else='')
            | {{props.formattedRow[props.column.field]}}

    .editor
      .content(v-if="active")
        .row.editor-row
          .name.col-xs-6.pull-left
            fpui-input-select(
              name="filterkey"
              :label="'editor.filter.attribute'|translate"
              :labelSize="3",
              :searchable="true",
              :direction="'top'",
              :value='active.name',
              :clearable="false",
              :options='filternames',
              :showSelected="true",
              :placeholder="'editor.filter.attribute.placeholder'|translate"
              @input="changeActiveName($event)"
            )
          .conditions.col-xs-6.pull-left
            fpui-input-select(
              name="filtecond"
              :label="'editor.filter.condition'|translate"
              :labelSize="4",
              :direction="'top'",
              v-model='active.condition',
              :clearable="false",
              :options='conditionsSelect',
              :showSelected="true"
              :searchable="true"
              :maxHeight="selectBoxHeight"
            )
        .clearfix
        .row.editor-row
          .value.col-xs-12.pull-left(v-if="valueType==='single'").single
            fpui-input-text(:placeholder="'editor.filter.value.placeholder'|translate",:autocomplete="autocomplete", :autocompletePosition="'top'", name="filtervalue",:value="active.value[0]",@input="setValueAt(0,$event)",:label="'editor.filter.value'|translate")
          .value.col-xs-12.pull-left(v-if="valueType==='multiple'").multiple
            .row
              .fpui-input-label-container.col-xs-3
                span {{'editor.filter.value'|translate}}
              .col-xs-9.values
                vue-tags-input(
                  :autocomplete-items="autocompleteTags"
                  ref="tagsInput"
                  v-model="search",
                  :tags="tagsActive",
                  :key="reRender"
                  @tags-changed="setValue"
                  :placeholder="'editor.filter.values.placeholder'|translate"
                )
          .value.col-xs-12.pull-left(v-if="valueType==='range'").range
            .row
              .fpui-input-label-container.col-xs-3
                span {{'editor.filter.value'|translate}}
              .col-xs-9.ranges
                fpui-input-text(:autocomplete="autocomplete", :autocompletePosition="'top'", name="range_min",:value="active.value[0]",@input="setValueAt(0,$event)",:placeholder="'editor.filter.range.min'|translate")
                fpui-input-text(:autocomplete="autocomplete", :autocompletePosition="'top'", name="range_max",:value="active.value[1]",@input="setValueAt(1,$event)",:placeholder="'editor.filter.range.max'|translate")
        .row.buttons
          fpui-button(color="red",@click='cancel',reverse,:icon-left="true",icon="fpui fpui-remove") {{'editor.filter.cancel'|translate}}
          span(:style="{ marginRight: '15px' }") &nbsp;&nbsp;&nbsp;&nbsp;
          fpui-button(v-if="!editState", color="blue",@click='confirm',reverse,:icon-left="true",icon="fa fa-save",:disabled="disabledSave()") {{'editor.filter.add'|translate}}
          fpui-button(v-if="editState", color="blue",@click='confirm',reverse,:icon-left="true",icon="fa fa-save",:disabled="disabledSave()") {{'editor.filter.save'|translate}}


      .placeholder(@click="create",v-if="!active")
        fpui-button(@click="changeHeight" color="blue",icon="fpui fpui-plus",unbordered,reverse,icon-left) {{'editor.filter.new'|translate}}
</template>

<script>
  import VueTagsInput from '@johmun/vue-tags-input'
  import {cloneDeep} from 'lodash'

  export default {
    components: {
      VueTagsInput
    },
    props: ['dataset', 'value', 'autocompleteItems', 'resizer'],
    data () {
      return {
        search: '',
        conditions: {
          'not_like': 'single',
          'like': 'single',
          'is_not_null': 'empty',
          'is_null': 'empty',
          'not_between': 'range',
          'between': 'range',
          'lt': 'single',
          'lte': 'single',
          'gt': 'single',
          'gte': 'single',
          'not_in': 'multiple',
          'in': 'multiple',
          'not_equal': 'single',
          'equal': 'single'
        },
        active: null,
        columns: [{
          label: this.$t('editor.filter.attribute_name'),
          field: 'name'
        }, {
          label: this.$t('editor.filter.condition'),
          field: 'condition'
        }, {
          label: this.$t('editor.filter.value'),
          field: (row) => {
            return [row.value].join(',') || row.value
          }
        }, {
          width: '100px',
          tdClass: 'options',
          field: 'options'
        }],
        editState: false,
        prevHeight: '',
        reRender: 0,
        selectBoxHeight: 0
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.selectBoxHeight = this.$refs.newFilter.getBoundingClientRect().height - 150
      })
    },
    methods: {
      changeHeight () {
        this.prevHeight = this.$refs.newFilter.getBoundingClientRect().bottom - 49.31 + 'px'
        this.selectBoxHeight = this.$refs.newFilter.getBoundingClientRect().height - 150 < 200 ? 200 : this.$refs.newFilter.getBoundingClientRect().height - 150
        if (this.resizer) this.resizer.setHeight({ height: '500px', type: 'new'})
      },
      disabledSave () {
        return !this.active.condition || !this.active.value || !this.active.name
      },
      setValue ($event) {
        this.active.value = $event.map(e => e.text)
      },
      setValueAt (index, $event) {
        this.$set(this.active.value, index, $event)
      },
      changeActiveName (value) {
        if (this.active.name === value) return
        this.active.name = value
        this.active.value = []
        this.$emit('autocomplete', value)
      },
      onRowClick ({row}) {
        this.edit(row)
      },
      edit (row, $event) {
        this.editState = true
        this.active = cloneDeep(row)
        this.active.old = row
        this.$emit('autocomplete', row.name)
        if ($event) $event.stopPropagation()
      },
      remove (row, $event) {
        let value = cloneDeep(this.value)
        delete value[row.name][row.condition]
        if (!Object.keys(value[row.name]).length) delete value[row.name]
        this.$emit('input', value)
        this.active = null
        $event.stopPropagation()
      },
      create () {
        this.active = {
          value: [],
          condition: 'equal'
        }
      },
      cancel () {
        if (this.resizer) this.resizer.setHeight({ height: this.prevHeight, type: 'cancel'})
        this.editState = false
        this.active = null
      },
      confirm () {
        if (!this.active.condition || !this.active.value || !this.active.name) return
        let value = cloneDeep(this.model)
        if (this.active.old) {
          delete value[this.active.old.name][this.active.old.condition]
          if (!Object.keys(value[this.active.old.name]).length) delete value[this.active.old.name]
        }
        value[this.active.name] = value[this.active.name] || {}

        if (this.valueType === 'single') value[this.active.name][this.active.condition] = [this.active.value[0]]
        else if (this.valueType === 'range') value[this.active.name][this.active.condition] = [this.active.value[0], this.active.value[1]]
        else value[this.active.name][this.active.condition] = (this.active.value + '').split(',')

        this.$emit('input', value)
        this.active = null
        this.editState = false
      }
    },
    watch: {
      'value' (value) {
        if (value) {
          this.active = null
          this.$emit('autocomplete', null)
        }
      },
      // re-render vue tag input to fix bug on mouse click
      'active.value' () {
        this.reRender++
        if (this.$refs.tagsInput && this.$refs.tagsInput.$refs) {
          setTimeout(() => {
            this.$refs.tagsInput.$refs.newTagInput.focus()
          })
        }
      }
    },
    computed: {
      model () { return this.value || {} },
      autocompleteTags () {
        try {
          return this.autocompleteItems.filter(i => new RegExp(this.search, 'i').test(i))
            .map(e => {
              return {
                text: e
              }
            })
        } catch (err) {
          return []
        }
      },
      autocomplete () {
        return this.autocompleteItems
      },
      tagsActive () {
        return this.active.value.map(e => {
          return {
            text: e
          }
        })
      },
      conditionsSelect () {
        return Object.keys(this.conditions).map(c => {
          return {
            value: c,
            label: this.$t('editor.filter.cond.' + c)
          }
        })
      },
      valueType () {
        return this.conditions[this.active.condition]
      },
      filternames () {
        const filters = [...this.dataset.filters]
        return filters.sort().reverse().map(f => {
          return {
            value: f,
            label: f
          }
        })
      },
      filters () {
        let filters = []
        if (!this.value) return filters
        for (let name in this.value) {
          if (!this.value[name]) continue
          for (let condition in this.value[name]) {
            filters.push({
              name,
              condition,
              value: this.value[name][condition]
            })
          }
        }
        return filters
      }
    }
  }
</script>

<style lang="less">
  @import "~@/shared/styles/_variables.less";
  .request-builder-filter {
    position: relative;
    height:100%;
    overflow: hidden;
    table tr td span, table tr th span {
      font-size:14px;
    }
    .vue-tags-input .input {
      height: 100% !important;
      min-height: 32px;
    }
    .filters {
      height:calc(~"100% - 33px");
      overflow:auto;
      .options {
        text-align:right;
        padding:0;
      }
      .empty-filter {
        color: #9a9a9a;
      }
    }
    .placeholder {
      text-align:center;
      margin-top:5px;
      margin-bottom:-10px;
    }
    .editor {
      background:white;
      position:absolute;
      border-top:1px solid #ddd;
      bottom:0;
      left:0;
      right:0;
      text-align:left;
      cursor:pointer;
      .range,.multiple {
        .fpui-input-label-container {
          padding:0;
        }
        .ranges,.values {
          padding:0;
          width:100%;
          .vue-tags-input {
            max-width:100%;
          }
          .fpui-input-text {
            width:calc(~"50% - 5px");
            float:left;
          }
          .fpui-input-text + .fpui-input-text {
            margin-left:10px;
          }
          .vue-tags-input .input {
            height:35px;
            padding:1px;
          }
          .tag {
            background:#e4f6fd;
            border:1px #00b8f6 solid;
            color:#00b8f6;
            .content {
              padding-top:0px;
              height:19px;
              font-size:12px;
            }
          }
        }
      }
      .content {
        padding-top:10px;
      }
      .text-right {
        text-align:right;
      }
      .editor-row {
        margin:7px 0;
      }
      .fpui-input-text.v3 {
        input {
          height:35px;
          padding:9px 8px;
        }
      }
      .buttons {
        text-align:center;
        &.buttons {
          margin-top: 15px;
        }
      }
      .value {
        .col-xs-3 {
          width:12%;
        }
        .col-xs-9 {
          width:88%;
        }
      }
      .fpui-input-label-container {
        line-height:35px;
        font-size:14px;
      }
      .single {
        .autocomplete-top {
          max-height: 200px;
        }
      }
    }
  }
</style>
